// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconPlaybackPlay = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.5479 55.9246C20.573 55.143 27.4466 53.2325 37.1112 47.6527C46.7759 42.0728 52.1495 36.7505 54.5566 33.9803C55.6603 32.7101 55.6603 31.2899 54.5566 30.0197C52.1495 27.2495 46.7759 21.9272 37.1112 16.3474C27.4466 10.7675 20.1506 8.77503 16.5479 8.07544C14.8961 7.75464 13.6661 8.46479 13.118 10.0557C11.9225 13.5255 10 20.8402 10 32C10 43.1598 11.9225 50.4746 13.118 53.9443C13.6661 55.5352 14.8961 56.2454 16.5479 55.9246Z" />
    </svg>
  );
};
